export default "* Pensel\n* Naturmaterialer\n* Male\n* Mønster";